import { render, staticRenderFns } from "./DropdownValidation.vue?vue&type=template&id=f0b21ee6&scoped=true&"
import script from "./DropdownValidation.vue?vue&type=script&lang=js&"
export * from "./DropdownValidation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0b21ee6",
  null
  
)

export default component.exports